import CategoryDoseFormMappingTable from 'components/CategoryDoseFormMapping';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const CategoryDoseFormMapping = () => {
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
	const isCategoryDoseFormMappingPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'CategoryDoseFormMapping',
			permission: ['viewAll'],
		}
	);
	return (
		<div>
			{isCategoryDoseFormMappingPermission && <CategoryDoseFormMappingTable />}
		</div>
	);
};
